import { Game } from '@/components/Game';
import { GlobalStyles } from '@/styles/GlobalStyles';

function App() {
  return (
    <>
      <GlobalStyles />
      <Game />
    </>
  );
}

export default App;
